import Vuex from 'vuex';

const state = {
  isValid: false,
  hasBeenSent: false,
};

const getters = {
  isValid: state => state.isValid,
  hasBeenSent: state => state.hasBeenSent,
};

const actions = {
  resetPassword: ({ state, commit, dispatch }, { method, action, data }) => {
		const agent = method.toLowerCase() === 'post' ? superagent.post : superagent.get;
		agent(action).send(data).set('accept', 'json').set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8').end((err, res) => {
			if(err) {
				commit('failed');
				return;
			}
			commit('success');
		});
  }
};

const mutations = {
	failed: (state) => {
		state.isValid = false;
		state.hasBeenSent = true;
	},
  success: (state) => {
    state.isValid = true;
		state.hasBeenSent = true;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ../shared/store/modules/resetpassword.js